<template>
  <div>
    <h1>Novo de Papel</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("acl", ["role"]),
  },
  methods: {
    ...mapActions("acl", ["ActionNewRole"]),
    loadData(id) {
      this.$router.push({ name: "acl_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewRole();
  },
};
</script>

<style></style>
